<!--  vertical layouts -->
<ng-scrollbar
  *ngIf="this.config['layout'] === 'vertical'"
  style="height: calc(100vh - 70px)"
  exclude="'#mobile-collapse1'"
  visibility="hover"
>
  <div class="navbar-content">
    <ul class="nav pcoded-inner-navbar" (clickOutside)="fireOutClick()" (mouseleave)="navMob()">
      <ng-container *ngFor="let item of navigation">
        <app-nav-group *ngIf="item.type === 'group'" [item]="item"></app-nav-group>
        <app-nav-collapse *ngIf="item.type === 'collapse'" [item]="item"></app-nav-collapse>
        <app-nav-item *ngIf="item.type === 'item'" [item]="item"></app-nav-item>
      </ng-container>
    </ul>
    <div class="version">
      <label for="version" disabled class="pe-auto">{{ currentApplicationVersion }}</label>
    </div>
  </div>
</ng-scrollbar>

<!-- horizontal layouts -->
<div *ngIf="this.config['layout'] === 'horizontal'" class="navbar-content sidenav-horizontal" id="layout-sidenav">
  <a href="javascript:" aria-label="scroll-right" class="sidenav-horizontal-prev" [ngClass]="prevDisabled" (click)="scrollMinus()"></a>
  <div #navbarWrapper class="sidenav-horizontal-wrapper">
    <ul
      #navbarContent
      id="side-nav-horizontal"
      class="nav pcoded-inner-navbar sidenav-inner"
      (clickOutside)="fireLeave()"
      (mouseleave)="fireLeave()"
    >
      <ng-container *ngFor="let item of navigation">
        <app-nav-group *ngIf="item.type === 'group'" [item]="item"></app-nav-group>
        <app-nav-collapse *ngIf="item.type === 'collapse'" [item]="item"></app-nav-collapse>
        <app-nav-item *ngIf="item.type === 'item'" [item]="item"></app-nav-item>
      </ng-container>
    </ul>
  </div>
  <a href="javascript:" aria-label="scroll-left" class="sidenav-horizontal-next" [ngClass]="nextDisabled" (click)="scrollPlus()"></a>
</div>
